export default __webpack_public_path__ + "static/media/smallimage.c05eb166.jpeg";